import { createStackNavigator } from '@react-navigation/stack'
import React from 'react'
import StaffScreen from '../components/staff/staffScreen'
import AddEditStaff from '../components/staff/addEditStaff'
import { forSlideFromLeftAnimation } from '../shared/hooks/funcions'
import ActivityLogs from '../components/profile/activityLog/activityLogs'
import AddEditRole from '../components/role/addEditRole'


const StaffStack = () => {
    const Staff = createStackNavigator()

    return (
        <Staff.Navigator screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation, }} initialRouteName='StaffScreen' >
            <Staff.Screen name='StaffScreen' component={StaffScreen} />
            <Staff.Screen name='AddEditStaff' component={AddEditStaff} />
            <Staff.Screen name='StaffLoginHistory' component={ActivityLogs} />
            <Staff.Screen name='AddRole' component={AddEditRole} />
        </Staff.Navigator>
    )
}
export default StaffStack
